var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit-05",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "edit-05-2",
    "data-name": "edit-05",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4,8.3a2.853,2.853,0,0,1,.037-.643A1.333,1.333,0,0,1,4.2,7.27a2.853,2.853,0,0,1,.428-.48L11,.414a1.414,1.414,0,0,1,2,2L6.625,8.789a2.853,2.853,0,0,1-.48.428,1.334,1.334,0,0,1-.385.16,2.853,2.853,0,0,1-.643.037H4Z",
    transform: "translate(1.333 1.252)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon-2",
    "data-name": "Icon",
    d: "M12,7.414v2.8a4.969,4.969,0,0,1-.218,2.108,2,2,0,0,1-.874.874,4.969,4.969,0,0,1-2.108.218H3.2A4.969,4.969,0,0,1,1.092,13.2a2,2,0,0,1-.874-.874A4.969,4.969,0,0,1,0,10.214v-5.6A4.969,4.969,0,0,1,.218,2.506a2,2,0,0,1,.874-.874A4.969,4.969,0,0,1,3.2,1.414H6",
    transform: "translate(1.333 1.252)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e1924083f9052be247705d36eb7c9121.svg";
export { ForwardRef as ReactComponent };